import React from 'react';
import styles from './AlertMessage.module.css';
import IMAGES from '../../assets/images/images';
import parse from 'html-react-parser';

const AlertMessage = ({ alertHeader,alertMessage, onClose }) => {
  return (
    <div className={styles.alertmessage}> 
      <div className={styles.alertcontent}>
      <div className={styles.header}>
      <div className={styles.errormsghead}>{alertHeader}</div>
      <div className={styles.closes}> <img className={styles.close} onClick={onClose} src={IMAGES.close}/></div>
      </div>
        <div className={styles.errormsg}>{parse(alertMessage)}</div>
        <div className={styles.buttonok}>
        <button className={styles.buttonscan} onClick={onClose}>OK</button>
        </div>
      </div>
    </div>
  );
};

export default AlertMessage;